import { Component, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Disposable } from "@modules/common";
import { required } from "@rxweb/reactive-form-validators";
import { GeolocationService } from "@services";
import { filter, skipWhile, tap } from "rxjs/operators";

@Component({
  selector: "abi-gps-tracking-field",
  templateUrl: "./gps-tracking-field.component.html",
  // styleUrls: ["./number-input.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GPSTrackingFieldComponent),
      multi: true
    }
  ]
})
export class GPSTrackingFieldComponent extends Disposable implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() errors: string[];
  @Input() label: string;
  currVal: Partial<GeolocationPosition> = null;
  isDisabled: boolean;
  private onChanged = (_: any) => { };
  onTouched = () => { };

  static validationMessages = {
    required: "Geo/Location Services are required. Please ensure this Service is active and Enabled for this Site."
  };

  constructor(private locationService: GeolocationService) {
    super();
  }

  // location tracking
  sample = true;// triggers location sampling process
  trackingIteration = 0;// track iterations
  @Input() trackingMaxIteration = 4;

  ngOnInit() {
    // trigger tracking on location fetch interval (5seconds)
    this.locationService.locationObs
    .pipe(
      this.notDisposed(),
      // tap((loc) => console.log('Tap Location:', loc)),
      filter((location) => this.sample),// safety to prevent re-captures after it's closed
      tap(location => {// check if more sampling is required...
        console.log('Location:', location);
        if (GeolocationService.isError(location as GeolocationPositionError)) {
          console.log('Geo/Location Services are required. Please ensure this Service is active and Enabled for this Site.');
          // this.snackBar.warning('Geo/Location Services are required. Please ensure this Service is active and Enabled for this Site.');
          // this.control.setErrors({ location: 'Geo/Location Services are required. Please ensure this Service is active and Enabled for this Site.' });
        } else {
          this.trackingIteration +=1;//track samples
          this.sample = false;// prevent further sampling
        }
      }),
      skipWhile((location) => GeolocationService.isError(location as GeolocationPositionError)),
      // no errors past here
    )
    .subscribe(
      (res) => {
        // console.log('Res:', res, this.trackingIteration, this.trackingMaxIteration, this.sample);
        this.updateValue(res as GeolocationPosition);
        // we wait for update response - then we can determine if additional iterations (samples) need to be taken
        if(this.busyTracking){
          // const [lat, long] = res.actualStartLocation.split(',').map(val => Number.parseFloat(val));// location as GeolocationPosition;
          // const outOfThreshold = this.showDistanceThresholdWarning(this.visit.address.gpsCoordinates, [lat, long]);
          // if(outOfThreshold && this.trackingIteration <= this.trackingMaxIteration){
          if(this.trackingIteration <= this.trackingMaxIteration){
            this.sample = true;
            // keep iterating
          } else {
            this.resetCheckInTracking();
          }

        }
        // always update the page's dto
        // this.visit = res as CustomerVisitAndRating;
      }
    );

    this.startCheckInTracking();
  }

  writeValue(obj: GeolocationPosition): void {
    this.currVal = obj;
    console.log('Write Value:', obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  updateValue(value: GeolocationPosition) {
    // have to read each value separtely...
    this.currVal = {coords: {heading: value.coords.heading ,latitude: value.coords.latitude, longitude: value.coords.longitude, accuracy: value.coords.accuracy, speed: value.coords.speed, altitude: value.coords.altitude, altitudeAccuracy: value.coords.altitudeAccuracy}, timestamp: value.timestamp};
    this.onChanged(this.currVal);
    this.onTouched();
  }

  // tracking methods
  static TRACKING_MESSAGE = "Aquiring accurate Location... (please wait)";
  busyTracking = false;
  displayMessage = "";
  startCheckInTracking(){
    this.busyTracking = true;
    this.displayMessage = GPSTrackingFieldComponent.TRACKING_MESSAGE;
    this.trackingIteration = 0;
    this.sample = true;

    this.locationService.interval = 5000; // reduce checking intervals to get more uptodata location when
    this.locationService.startLocationLoop();
  }

  resetCheckInTracking(){
    this.busyTracking = false;
    this.displayMessage = "";
    this.trackingIteration = 0;
    this.sample = false;

    this.locationService.stopLocationLoop();
  }

  ngOnDestroy(): void {
    console.log('Destroying GPS Tracking Field');
    super.ngOnDestroy();
    this.resetCheckInTracking();
  }

}
